import { numberFormatterPTBR } from '../../../../helpers/numbersFormatters';
import {
  allFirstLettersToUpperCase,
  firstLetterToUpperCase,
  getTextBetweenParentheses,
  removePercentile,
  removeTextBetwweenParentheses,
} from '../../../../helpers/textFormatter';
import {
  Ages,
  ConsumptionPattern,
  ExistingRealtiesChartData,
  MaritalStatus,
  MonthlyIncome,
  OwnersByAgeTableChartData,
  OwnersByConsumptionPatternTableData,
  OwnersByMaritalStatusChartData,
  OwnersByMonthlyIncomeTableData,
  OwnersBySchoolingChartData,
  PricePerSqMtMedianChartData,
  Schooling,
  TransactionedOverExistingRealtiesChartData,
} from '../components/types/realtyTransactions.types';

export const buildExistingRealties = (
  existingRealtiesYears: Record<string, number>
): ExistingRealtiesChartData[] =>
  Object.entries(existingRealtiesYears).map(
    ([year, count]) =>
      ({
        period: year,
        value: count,
        type: 'year',
        year: year,
        quarter: null,
        month: null,
      } as const)
  );

export const buildOwnersByMontlyIncome = (
  ownerByMontlyIncome: Record<string, { quantidade: string; media: string }>
): OwnersByMonthlyIncomeTableData[] =>
  Object.entries(ownerByMontlyIncome)
    .map(([income, info]) => ({
      monthly_income: income as MonthlyIncome,
      number_of_owners: info.quantidade,
      average_income: numberFormatterPTBR(info.media),
    }))
    .reverse();

export const buildOwnersByAge = (buildOwnersByAge: {
  idade_feminina: Record<string, string>;
  idade_masculina: Record<string, string>;
  idade_total: Record<string, string>;
}): OwnersByAgeTableChartData[] => {
  return Object.entries(buildOwnersByAge.idade_total).map(([type, data]) => ({
    age: firstLetterToUpperCase(type) as Ages,
    male: Number(removePercentile(buildOwnersByAge.idade_masculina[type])),
    female: Number(removePercentile(buildOwnersByAge.idade_feminina[type])),
    total: Number(removeTextBetwweenParentheses(data)),
    percentile: data,
  }));
};

export const buildOwnersBySchooling = (
  ownersBySchooling: Record<string, string>
): OwnersBySchoolingChartData[] =>
  Object.entries(ownersBySchooling).map(([schooling, value]) => ({
    schooling: schooling as Schooling,
    total: Number(removePercentile(getTextBetweenParentheses(value))),
    percentile: getTextBetweenParentheses(value),
    label: value,
  }));

export const buildOwnersByMaritalStatus = (
  ownersByMaritalStatus: Record<string, string>
): OwnersByMaritalStatusChartData[] =>
  Object.entries(ownersByMaritalStatus).map(([maritalStatus, value]) => ({
    marital_status: maritalStatus as MaritalStatus,
    percentile: value,
    value: Number(removePercentile(value)),
  }));

export const buildOwnersByConsumptionPattern = (
  ownewByConsumptionPattern: Record<string, string>
): OwnersByConsumptionPatternTableData[] =>
  Object.entries(ownewByConsumptionPattern).map(
    ([consumptionPattern, value]) => ({
      consumption_pattern: consumptionPattern as ConsumptionPattern,
      value: value,
    })
  );

export const buildPricePerSqMtMedian = (
  pricePerSqMtMedian: Record<string, string>
): PricePerSqMtMedianChartData[] =>
  Object.entries(pricePerSqMtMedian).map(([year, value]) => ({
    period: year,
    value: Number(value),
    type: 'year',
    year: year,
    quarter: null,
    month: null,
  }));

export const buildTransactionedOverExistingRealties = (
  transacitionedOverExistingRealties: Record<
    string,
    Record<string | number, string | number>
  >
): TransactionedOverExistingRealtiesChartData[] =>
  Object.entries(transacitionedOverExistingRealties).map(
    ([year, data]) =>
      ({
        value: Number(data),
        type: 'year',
        id: year,
        transactioned_percent: Number(
          removePercentile(data.porcentagem as string)
        ),
      } as const)
  );
